import { LegalDocumentPage } from "../components/legal/LegalDocumentPage";
import { TERMS_OF_SERVICE_DOCUMENT } from "../legal/legal.content";

export default function TermsOfService() {
  return <LegalDocumentPage document={TERMS_OF_SERVICE_DOCUMENT} />;
}
